export default function(){
    (function($) {

        // $(document).ready(function () {
        $(window).on('load', function () {
            $('.marquee').each(function(){
                var $this = $(this);
                var $text = $this.find('.marquee__text');
                var $firstTextWidth = $text.outerWidth();
                var $textWidth = $firstTextWidth;
                if ( $textWidth < $(window).width()) {
                    for ($textWidth; $textWidth < $(window).width();) {
                        $this.find('.marquee__container').append($text.clone());
                        $textWidth += $firstTextWidth;
                    }
                } else {
                    $this.find('.marquee__container').append($text.clone());
                }
                $('.marquee__text').css('animation', 'slideLeft 8s linear infinite');
            });
        });

    })(jQuery);
}